export default __webpack_public_path__ + "static/media/ab-img.fe317ef5.png";